module.exports = __webpack_public_path__ + "static/media/casual_shirt_canvas.fcbf7dd0.svg";